// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__26C-R","inner":"Footer_inner__xx3vb"};